import React from "react";
import "./style.css";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { renderDetalle } from "./utils";
import ForwardIcon from "@material-ui/icons/Forward";
import ItemWrapper from './card/ItemWrapper';

const useStyles = makeStyles(theme => ({
    paper: {
        marginLeft: "34%",
        marginTop: "10%",
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 4)
    }
}));
const ItemAfuera = props => {
    const classes = useStyles();

    return (
        <ItemWrapper className={"itemAfuera"} pedido={props.pedido}>
            {renderDetalle(props.pedido)}
            <Button size="small" onClick={() => props.avanzar(props.pedido, props.index)}>
                <ForwardIcon />
            </Button>
        </ItemWrapper>
    );
};

export default ItemAfuera;
